<template>
  <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
    <div class="text-v-ui-gray-900 text-[20px] font-semibold leading-[120%]">
      Общие сведения
    </div>

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Наименование КЗС
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsData.name }}</div>
    </div>

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Наименование нозологии
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsData.nosology.name }}</div>
    </div>
    <!-- End form item -->

    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Диагнозы МКБ
      </div>
      <div class="flex gap-x-[8px] gap-y-[8px] flex-wrap">
        <VAttribute
          v-for="diagnosis in kzsData.nosology.diagnoses"
          :key="diagnosis.id"
          :content="diagnosis.mkbCode"
        />
      </div>
    </div>
    <!-- End form item -->

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Шаблон задачи по результатам срабатывания КЗС
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsData.assignmentTemplateName }}</div>
    </div>
    <!-- End form item -->

    <!-- Form item -->
    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Описание КЗС
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsData.description || "-" }}</div>
    </div>
    <!-- End form item -->
  </div>
</template>

<script>
import { VAttribute } from '@gostelemed.front/rt-doctis.designsystem';

export default {
  components: {
    VAttribute,
  },
  name: 'KzsViewCommonSettings',
  props: {
    kzsData: {
      type: Object,
      required: false,
    },
  },
}
</script>
